import type { IFieldDefinition, IRecordTypeDefinition } from '@platform/core/types';
import { visibleFields } from './formRules';

/**
 * Поля типу в порядку простору (m.fields прототипу v4, від якого залежать стандартні групи): поля визначення, де поля, розміщені в
 * контекстній формі (її редактор не змінює; вона несе порядок форми простору — і опублікований, і парламентський), стоять у порядку цієї
 * форми на місцях своєї послідовності; решта полів — на своїх місцях. Чиста функція.
 */
export function workspaceFieldsOf(rt: IRecordTypeDefinition): IFieldDefinition[] {
  const fields = visibleFields(rt);
  const known = new Set(fields.map((f) => f.key));
  const form = rt.forms?.context?.groups?.length ? rt.forms.context : rt.form;
  const order = [...new Set(form.groups.flatMap((g) => g.fields))].filter((k) => known.has(k));
  const placed = new Set(order);
  const byKey = new Map(fields.map((f) => [f.key, f]));
  let next = 0;
  return fields.map((f) => (placed.has(f.key) ? byKey.get(order[next++]!)! : f));
}
